<template>
	<v-container>
		<h1>Asignar</h1>
		<span v-if="idSolicitud == 0">
			<v-row>
				<v-col cols=12>
					<PacientesPendientes @solicitud-seleccionada="eligeSolicitud"/>
				</v-col>
			</v-row>
		</span>
		<span v-if="idSolicitud != 0">
			<v-row>
				<v-col cols="12">
					<Citas :datosSolicitud="datosParaSolicitud" @estatus-solicitud="estatus"/> 
				</v-col>
			</v-row>
		</span>
		<v-snackbar v-model="activarDesactivar">
			{{ mensaje }}
			<v-btn color="pink" text @click="activarDesactivar = false">Cerrar</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import PacientesPendientes from '@/components/PacientesPendientes'
import Citas from '@/components/Citas'
export default {
	name: 'Asignar',
	components: {
		PacientesPendientes,
		Citas,
	},
	data() {
		return {
			nombreUsuario: '',
			esAdmin: false,
			idSolicitud: 0,
			fechaSolicitud: '',
			datosParaSolicitud: [],
			activarDesactivar: false,
			mensaje: '',
		}
	},
	mounted: function() {
		if(!this.$session.exists()){
			this.$router.push('/login')
		} else {
			this.nombreUsuario = this.$session.get('nombre')
			this.esAdmin = this.$session.get('esAdmin')
			if(!this.esAdmin){
				this.$router.push('/')
			}
		}
	},
	methods: {
		eligeSolicitud(event) {
			const infoSolicitud = {
				idSolicitud : event.idSolicitud,
				fechaSolicitud : event.fechaSolicitud,
				paciente: event.nombre
			}
			this.idSolicitud = event.idSolicitud
			this.fechaSolicitud = event.fechaSolicitud
			console.log("infoSolicitud", infoSolicitud)
			this.datosParaSolicitud = infoSolicitud
			console.log("datosParaSolicidud", this.datosParaSolicitud)
			console.log("idSolicitud", event.idSolicitud)
		},
		estatus(event) {
			console.log("Valores del evento", event)
			this.idSolicitud = event.idSolicitud
			this.activarDesactivar = true
			this.mensaje = event.mensaje
			console.log("evento cancelar, idSolicitud", event)
		}
	}
}
</script>
